<template>
    <div class="">
      <el-dialog
          title="服务项目"
          :visible.sync="showDialog"
          width="65%"
          :before-close="closeDialog"
          append-to-body
          :show-close="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :modal-append-to-body="false"
        >
        <div v-loading="loading">
        <el-tabs tab-position="left"  style="height: 400px;">
          
            <el-tab-pane v-for="item in treeData" :key="item">
              <div  slot="label">
                <span>
                    {{item.name}}
                </span>
                <span style="color:#F56C6C;">{{item.tagNUmber>0?item.tagNUmber:''}}</span>
              </div>
              <div class="checkbox-content">
                <!-- <el-checkbox-group v-model="item.result" @change="checkedServiceProject">    
                  <el-row>
                    <el-col v-for="node in item.itemLists" :key="node" span="8">
                      <el-checkbox :label="node.id" border @click="checkNode(node)" >
                        {{ node.serviceContent }} <span style="margin-left:15px;">{{ node.score }}分</span> 
                      </el-checkbox>

                    </el-col>
                  </el-row> 
                </el-checkbox-group> -->
                <el-row>
                    <el-col v-for="node in item.itemLists" :key="node" span="12">
                      <div style="margin-bottom:15px;">
                        <div>
                          {{ node.serviceContent }}  
                        </div>
                        <span style="color:#F99B34">￥{{tool.money_format(node.price)}}</span><span style="margin:10px;">{{ node.score }}分</span>
                        <el-input-number @change="projectNumberChange" size="mini"  step="1" step-strictly  :min='0' :max="999999" v-model="node.consumeNum"></el-input-number>
                      </div>
                      
                    </el-col>
                  </el-row> 
               </div>
            </el-tab-pane>
           
        </el-tabs>
       </div>
       <template slot="footer">
         <div class="footer">
            
            <el-button type="primary" @click="confirm">保存</el-button>
            <el-button @click="cancel">取消</el-button>
         </div>
       </template>
        </el-dialog>
        
    </div>
</template>
<script>
import {getItemByModuleType,editServiceProject} from "@/api/crmedical/order/order-list/order-list";
export default {
    props:{
        // 已选择的数据，数据回显做准备
        checked:{
            type:Array,
            default:[],
        },
        // 初始化数据
        data:{
            type:Array,
            default:[],
        },
        treeData:{
          type:Array,
          default:[],
        }

    },
    data(){
        return{
          checkList:'',
          showDialog:false,
          // 树 的数据
          loading:false,
          projectId:'',
          


        
        };
    },
    
    methods:{
      projectNumberChange(){
          this.treeData.forEach(ele=>{
            let tagNUmber = 0;
            ele.itemLists.forEach(item=>{
              if(Number(item.consumeNum)>0){
                tagNUmber += Number(item.consumeNum);
              }
            })
            ele.tagNUmber = tagNUmber;
          })
      },
      // 修改服务项目提交
      editServiceProject({itemListIds,success,error}){
        let recordVO = {
          orderId:this.orderId,
          itemListIds:itemListIds,
        }
        editServiceProject(recordVO).then(res=>{
          success(res)
        }).catch(res=>{
          error(res)
        })
      },
      // 选择服务项目
      checkNode(node){
        
        let flag = true;
        this.checked.forEach((ele,index)=>{
          if(ele.id == node.id){
            flag = false;
            this.checked.splice(index,1)
          }
        })
        if(flag){
          this.checked.push(node);
        }
      },
      // 确认添加耗材 关闭弹窗
      confirm(){
        
        this.checked = [];
        let itemListIds = [];
        this.treeData.forEach(ele=>{
          ele.itemLists.forEach(item=>{
             if(Number(item.consumeNum)>0){
                item.serviceItemListId = item.id;
                item.itemId = item.id;
                item.number = item.consumeNum;
                itemListIds.push(item);
              }
          })
        })
        let self = this;
        self.showDialog = false;
        console.log(itemListIds)
        this.editServiceProject({
          itemListIds:itemListIds,
          success(res){//修改成功
            if(res.success){
              self.$message({
                message: '保存成功！',
                type: 'success'
              });
              // self.$emit("update:checked",itemListIds)
              self.$emit("refresh");
              self.showDialog = false;
            }else{
              self.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          },
          error(res){ //修改失败
            
          }
        });
      },
      // 取消选择 关闭弹窗
      cancel(){
        this.showDialog = false;
      },

      // 选择服务项目
      checkedServiceProject(e){
        console.log(e)
        // console.log(this.treeData)
      },
      openSelectTree(data,checked){
        console.log('openSelectTree',data)
        this.loading = true;
        this.showDialog = true;
        this.projectId = data.projectId;
        this.orderId = data.id;
        this.subModuleId = data.subModuleId
        if(!this.subModuleId || this.subModuleId=='null'){
          this.subModuleId = "";
        }
        
        getItemByModuleType({projectId:this.projectId,moduleType:data.moduleType,subModuleId:this.subModuleId}).then(res=>{
            res.data.forEach(ele => {//将选择的数据展示出来
              let tagNUmber = 0;
              checked.forEach(checked=>{
                if(checked.itemId==ele.id){
                  tagNUmber += Number(checked.consumeNum)
                }

              })
              ele.itemLists.forEach(item=>{
                checked.forEach(checked=>{
                  console.log(checked.serviceItemListId == item.id)
                  if(checked.serviceItemListId == item.id){
                  
                    item.consumeNum = Number(checked.consumeNum);
                    
                  }

                })
              })
              ele.tagNUmber = tagNUmber;
            });
            console.log(res.data)
            this.treeData = res.data;
            if(this.treeData.length==0){
              this.$message({
                message: "暂无数据",
                type: 'warning'
              });
            }
            this.loading = false;
        }).catch(res=>{
          this.loading = false;
            this.$message({
              message: res.msg,
              type: 'warning'
            });
        })
      }

    }
    
}
</script>

<style lang="scss" scoped>
    .checkbox-content{
      height: 400px;
      overflow-y: auto;
    }
    .checkbox-title{
      width: 120px;
      height: 100px;
      background-color: #eee;
      overflow: hidden;
      display: flex;
      word-break:normal ;
      flex-wrap: wrap;

    }
    .footer{
      display: flex;
      justify-content: flex-end;

    }
</style>>